import { QueryClient } from '@tanstack/react-query';

export const permissionQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 24 * 60 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
    },
  },
});
